module.exports = __webpack_public_path__ + "static/media/LAYREPAS_007_CONTRATANTE.b40e0386.txt";